import { makeStyles, Text } from "@fluentui/react-components";
import { useTranslation } from "react-i18next";
import IContactDetailsProps from "./IContactDetailsProps";

const useStyles = makeStyles({
    link: {
        textDecoration: "none",
        color: "inherit",
    }
})

const ContactDetails = (props: IContactDetailsProps) => {
    const { isLoading, phone } = props;
    const { t } = useTranslation("contact");
    const styles = useStyles();

    return (
        <div>
            <Text block>
                {t("titles.contactUs").toUpperCase()}
            </Text>
            
            {
                !isLoading && phone &&
                <Text block>
                    {t("details.phone.title")} <a href={`tel:${phone}`} className={styles.link}>{phone}</a>
                </Text>
            }

            <Text block>
                {t("details.email.title")} <a href={`mailto:${t("details.email.value")}`} className={styles.link}>{t("details.email.value")}</a>
            </Text>
        </div>
    );
};

export default ContactDetails;